























































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BaseProperties from './BaseProperties.vue';
import LayoutCss from './LayoutCss.vue';
import ContentCss from './ContentCss.vue';
import TypographyCss from './TypographyCss.vue';
import BorderBgCss from './BorderBgCss.vue';
import { ResponsiveSizes, ComponentModel } from '@/models';

@Component({
  components: {
    BaseProperties,
    LayoutCss,
    ContentCss,
    TypographyCss,
    BorderBgCss
  }
})
export default class PropertiesView extends Vue {
  @Prop()
  model!: ComponentModel;
  @Prop()
  responsiveSize!: ResponsiveSizes;

  typesWithText: string[];

  constructor() {
    super();
    this.typesWithText = [
      'Label',
      'Span',
      'Textarea',
      'Button',
      'Option',
      'DataCell',
      'HeaderCell',
      'Anchor'
    ];
  }

  sizeSelected(event: any) {
    const value = parseInt(event.target.value, 10);
    this.$store.commit('setResponsiveSize', value);
  }

  get interactivityProperties() {
    if (!this.model) return null;
    return this.model.getCss('interactivity', this.responsiveSize);
  }

  get hasText(): boolean {
    return this.typesWithText.indexOf(this.model.typeName) >= 0;
  }

  get isLabel(): boolean {
    return this.model.typeName === 'Label';
  }

  get isSpan(): boolean {
    return this.model.typeName === 'Span';
  }

  get isInput(): boolean {
    return this.model.typeName === 'Input';
  }

  get isCheck(): boolean {
    return this.model.typeName === 'Check';
  }

  get isButton(): boolean {
    return this.model.typeName === 'Button';
  }

  get isTextarea(): boolean {
    return this.model.typeName === 'Textarea';
  }

  get isSelect(): boolean {
    return this.model.typeName === 'Select';
  }

  get isOption(): boolean {
    return this.model.typeName === 'Option';
  }

  get isAnchor(): boolean {
    return this.model.typeName === 'Anchor';
  }
}
